import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Col, Flex, Form, Input, Row, Tooltip } from "antd";
import { SectionHeader } from "../../components/SectionHeader/SectionHeader";
import { getSalesTerritories } from "../Dashboard/dashboardSlice";
import { buildQueryString, debounce } from "../../utils/helpers";
import { HeaderCell } from "../Dashboard/HeaderCell";
import { IconDownload } from "../../components/IconDownload/IconDownload";
import { IconSearch } from "../../components/IconSearch/IconSearch";
import { MainButton } from "../../components/MainButton/MainButton";
import { Notification } from "../../components/Notification/Notification";
import { dateCell } from "../../components/DateCell/DateCell";
import Table from "../../components/SortableTable/SortableTable";
import { CSVLink } from "react-csv";
import dayjs from 'dayjs';

export const SalesTerritories = ({upc}) => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  
  const [sortDirection, setSortDirection] = useState("");
  const [showNotification, setShowNotification] = useState(false);
	const [pageSize, setPageSize] = useState(10);

  const page = new URLSearchParams(location.search).get("page") || 1;
  const search = new URLSearchParams(location.search).get("search");
  const sort = new URLSearchParams(location.search).get("sort");

  // const onQueryParamsChange = (values) => {
	// const queryParams = {
	//   upc,		
	//   page,
	//   search,
	//   sort,
	//   ...values,
	// };
	// //SetState?
	// //const queryString = buildQueryString("/overview", queryParams);
	// //navigate(queryString);
  // };

	const onQueryParamsChange = (values) => {
		const queryParams = {
			upc,
			search,
			sort,
			...values,
		};

		const params = new URLSearchParams(queryParams);
		navigate(`?${params.toString()}`);
	};

  const { salesTerritories, getSalesTerritoriesInProgress } =
	useSelector((state) => state?.dashboard) || {};

  const { data: rows, total_rows } = salesTerritories || {};
  const [sortedTableData, setSortedTableData] = useState(rows);
  
  const handleDataUpdate = (data) => {
	  setSortedTableData(data);
  };

  useEffect(() => {
		dispatch(
			getSalesTerritories({
				upc,  
				page,
				search,
				sort: sortDirection,
				page_size: pageSize
			}),
		);
  }, [upc]);

	useEffect(() => {
		if (total_rows) {
			setPageSize(total_rows);
		}
	}, [total_rows]);

	useEffect(() => {
		if (rows && rows.length > 0) {
			handleDataUpdate(rows);
		}
	}, [rows]);

  const columns = [
  {
	title: "Territory",
	editable: true,
	dataIndex: "Territory",
	sorter: true,
	sortDirections: ['ascend', 'descend', undefined], 
	width: 200,
	align: "left",
	showSorterTooltip: false,
  },
  {
	title: (
		<Tooltip title="Stock on hand at consignment accounts">
		  <div>Cons. Stock</div>
		</Tooltip>
	  ),
	editable: true,
	dataIndex: "ConsStock",
	sorter: true,
	width: 150,
	align: "left",
	showSorterTooltip: false,
  },
  {
	title: (
		<Tooltip title="Total territory sales to date - direct sales accounts only">
		  <div>Direct Sales</div>
		</Tooltip>
	  ),

	editable: true,
	dataIndex: "DirectSales",
	sorter: true,
	width: 150,
	align: "left",
	showSorterTooltip: false,
  },
  {
	title: (
		<Tooltip title="Total territory sales to date - consignment accounts only">
		  <div>Cons. Total Sales</div>
		</Tooltip>
	  ),

	editable: true,
	dataIndex: "ConsTotalSales",
	sorter: true,
	width: 150,
	align: "left",
	showSorterTooltip: false,
  },
  {
	title: (
		<Tooltip title="Past seven-day sales total at consignment accounts">
		  <div>Cons. 7 Day Sales</div>
		</Tooltip>
	  ),

	editable: true,
	dataIndex: "ConsSevenDaySales",
	sorter: true,
	width: 150,
	align: "left",
	showSorterTooltip: false,
  },
  {
	title: (
		<Tooltip title="Total sales to date - direct and consignment accounts combined">
		  <div>Total Sales</div>
		</Tooltip>
	  ),

	editable: true,
	dataIndex: "TotalSales",
	sorter: (_, __, sort) =>
	  setSortDirection(`TotalSales:${sort === "ascend" ? "asc" : "desc"}`),
	width: 150,
	align: "left",
	showSorterTooltip: false,
  }

];

  const exportedCSVFile = `Sales-Territories-${upc}-${dayjs().format('YYYY-MM-DD')}.csv`;
  
  return (
		<Flex className={""} vertical>
			<SectionHeader title="Territories">
				<CSVLink data={sortedTableData || []} filename={exportedCSVFile}>
					<IconDownload />
				</CSVLink>
			</SectionHeader>
			<Table
				components={{
					header: {
						row: HeaderCell,
					},
				}}
				columns={columns}
				rowKey={(record) => record.territory}
				dataSource={rows}
				onDataChange={handleDataUpdate}
				pagination={{
					position: ["bottomRight"],
					responsive: true,
					current: page,
					// total: totalPages * 10,
					total: total_rows,
					defaultPageSize: total_rows,
					hideOnSinglePage: false,
					showSizeChanger: true,
					itemRender: (page, type, originalElement) => {
						if (total_rows <= pageSize && ['page', 'prev', 'next'].includes(type)) {
							return null;
						}
						return originalElement;
					},
					/*
					onChange: (page, pageSize) => {
						setPageSize(pageSize);
						onQueryParamsChange({ page });
					},
					*/
				}}
				loading={getSalesTerritoriesInProgress}
				style={{ marginTop: 10 }}
				scroll={{ x: "100%" }}
			/>
		</Flex>
  );
};
